import React from "react"
import { useEffect } from "react";
import { useState } from "react";

export function ActionButtons({
  hasNextPage,
  hasPreviousPage,
  nextPage,
  pageCount,
  pageIndex,
  pageSize,
  previousPage,
  setPageIndex,
  setPageSize,
  totalRows,
  totalRowsView
}) {

  const [ registros, setRegistro ] = useState(0);
  const [ totalRegistros, setRegistros ] = useState(pageSize);

  useEffect(()=>{
    handleShowPaginate();
  }, [pageIndex, totalRows])

  const handleShowPaginate = ()=>{
    const visibleData = totalRowsView.slice(
      pageIndex * pageSize,
      pageIndex * pageSize + pageSize
    );
    const paginaActual = (pageIndex +1);
    const nregistrosview = (pageSize*pageIndex+1);
    const ntotalRegistrosView = (visibleData.length+nregistrosview-1);
    if( paginaActual == 1 ){
      setRegistro( paginaActual )
      setRegistros( visibleData.length )
      return;
    }
    setRegistro( nregistrosview )
    setRegistros( ntotalRegistrosView )
  }

  return (
    <React.Fragment>
      <div className="d-flex gap-2 justify-content-between" style={{ fontSize: '13px' }}>
        <div>
          <span className="d-flex items-center gap-1" style={{ gap: '1rem'}}>
            Mostrando registros del {registros} al {totalRegistros} de un total de {totalRows} registros
          </span>
        </div>

        {/* <button
          className="border rounded p-1"
          onClick={() => setPageIndex(0)}
          disabled={!hasPreviousPage}
        >
          {"<<"}
        </button> */}
        <div className="d-flex gap-1" style={{ gap: '1rem' }}>
          <button
            className="border rounded p-1"
            type="button"
            onClick={() => previousPage()}
            disabled={!hasPreviousPage}
          >
            {"Anterior"}
          </button>
          <span style={{
            position: 'relative',
            top: '5px',
            fontWeight: 'bold'
          }}>
            { pageIndex +1 }
          </span>
          <button
            className="border rounded p-1"
            type="button"
            onClick={() => nextPage()}
            disabled={!hasNextPage}
          >
            {"Siguiente"}
          </button>
        </div>
        {/* <button
          className="border rounded p-1"
          onClick={() => setPageIndex(pageCount - 1)}
          disabled={!hasNextPage}
        >
          {">>"}
        </button> */}
        
        {/* <select
          className="border p-1 rounded"
          value={pageSize}
          onChange={e => {
            setPageSize(Number(e.target.value))
          }}
        >
          {[10, 20, 30, 40, 50].map(pageSize => (
            <option key={pageSize} value={pageSize}>
              Show {pageSize}
            </option>
          ))}
        </select> */}
      </div>
      {/* <div>{totalRows} Rows</div> */}
    </React.Fragment>
  )
}

export default ActionButtons
